type PathParts = {
  category?: string | null;
  city?: string | null;
  space?: string | null;
};


export const urlPattern = {
  build: ({ category, city, space }: Partial<PathParts>): string => {
    // Handle "all" city case
    if (category && (!city || city === 'all')) {
      return `/espacios/all/${category}`;
    }
    
    // Handle city-only case 
    if (city && !category) {
      return `/espacios/${city}`;
    }
    // Handle space detail case
    if (city && category && space) {
      return `/espacios/${city}/${category}/${space}`;
    }

    // Handle city + category case
    if (city && category) {
      return `/espacios/${city}/${category}`;
    }

    return '/';
  },
  parse: (pathname: string): PathParts => {
    // First check if this is a spaces route
    if (!pathname.startsWith('/espacios/')) {
      return { category: null, city: null, space: null };
    }

    // Remove 'espacios' prefix
    const pathWithoutPrefix = pathname.replace(/^\/espacios\//, '');
    const parts = pathWithoutPrefix.split('/').filter(Boolean);

    if (parts.length === 0) {
      return { category: null, city: null, space: null };
    }
    if (parts.length === 1) {
      return { category: null, city: parts[0], space: null };
    }
    if (parts[0] === 'all') {
      return { city: 'all', category: parts[1], space: null };
    }
    return {
      city: parts[0],
      category: parts[1] || null,
      space: parts[2] || null,
    };
  },
  isCategoryActive: (pathname: string, categoryValue: string): boolean => {
    const { category } = urlPattern.parse(pathname);
    return category === categoryValue;
  }
};
